import React from 'react';

// Mirrors SERVICE_THEMES in socket/src/index.js
const SERVICE_THEMES = {
  wifi: {
    bg: '#030c18',
    g1pos: '80% 48%', g1col: 'rgba(6,182,212,0.26)',
    g2pos: '15% 80%', g2col: 'rgba(56,189,248,0.13)',
    accent: '#38bdf8', accentGlow: 'rgba(56,189,248,0.42)',
    text: '#f0f9ff', muted: 'rgba(224,242,254,0.72)',
    badgeBg: 'rgba(56,189,248,0.13)', badgeBorder: 'rgba(56,189,248,0.28)', badgeText: '#7dd3fc',
  },
  facebook: {
    bg: '#020810',
    g1pos: '80% 42%', g1col: 'rgba(24,119,242,0.28)',
    g2pos: '15% 75%', g2col: 'rgba(66,153,255,0.10)',
    accent: '#4d90fe', accentGlow: 'rgba(24,119,242,0.46)',
    text: '#f8fafc', muted: 'rgba(226,232,240,0.72)',
    badgeBg: 'rgba(24,119,242,0.14)', badgeBorder: 'rgba(24,119,242,0.30)', badgeText: '#93c5fd',
  },
  instagram: {
    bg: '#090410',
    g1pos: '80% 30%', g1col: 'rgba(225,48,108,0.26)',
    g2pos: '22% 78%', g2col: 'rgba(247,119,55,0.13)',
    accent: '#e1306c', accentGlow: 'rgba(225,48,108,0.44)',
    text: '#fdf4ff', muted: 'rgba(250,232,255,0.72)',
    badgeBg: 'rgba(225,48,108,0.14)', badgeBorder: 'rgba(225,48,108,0.28)', badgeText: '#f9a8d4',
  },
  google_maps: {
    bg: '#030e08',
    g1pos: '78% 40%', g1col: 'rgba(52,168,83,0.24)',
    g2pos: '18% 72%', g2col: 'rgba(234,67,53,0.12)',
    accent: '#34a853', accentGlow: 'rgba(52,168,83,0.42)',
    text: '#f0fdf4', muted: 'rgba(220,252,231,0.72)',
    badgeBg: 'rgba(52,168,83,0.14)', badgeBorder: 'rgba(52,168,83,0.28)', badgeText: '#86efac',
  },
  google_review: {
    bg: '#0e0b02',
    g1pos: '76% 38%', g1col: 'rgba(251,188,4,0.24)',
    g2pos: '18% 72%', g2col: 'rgba(234,67,53,0.08)',
    accent: '#fbbc04', accentGlow: 'rgba(251,188,4,0.44)',
    text: '#fffbeb', muted: 'rgba(254,243,199,0.72)',
    badgeBg: 'rgba(251,188,4,0.10)', badgeBorder: 'rgba(251,188,4,0.28)', badgeText: '#fde68a',
  },
  tripadvisor: {
    bg: '#021008',
    g1pos: '78% 40%', g1col: 'rgba(0,170,108,0.26)',
    g2pos: '18% 72%', g2col: 'rgba(0,200,150,0.10)',
    accent: '#00aa6c', accentGlow: 'rgba(0,170,108,0.44)',
    text: '#ecfdf5', muted: 'rgba(209,250,229,0.72)',
    badgeBg: 'rgba(0,170,108,0.14)', badgeBorder: 'rgba(0,170,108,0.28)', badgeText: '#6ee7b7',
  },
  menu: {
    bg: '#0f0904',
    g1pos: '78% 36%', g1col: 'rgba(245,158,11,0.24)',
    g2pos: '15% 74%', g2col: 'rgba(180,83,9,0.10)',
    accent: '#f59e0b', accentGlow: 'rgba(245,158,11,0.44)',
    text: '#fffbeb', muted: 'rgba(254,243,199,0.72)',
    badgeBg: 'rgba(245,158,11,0.10)', badgeBorder: 'rgba(245,158,11,0.28)', badgeText: '#fcd34d',
  },
  website: {
    bg: '#070512',
    g1pos: '78% 38%', g1col: 'rgba(99,102,241,0.24)',
    g2pos: '18% 72%', g2col: 'rgba(139,92,246,0.12)',
    accent: '#818cf8', accentGlow: 'rgba(99,102,241,0.44)',
    text: '#f5f3ff', muted: 'rgba(237,233,254,0.72)',
    badgeBg: 'rgba(99,102,241,0.14)', badgeBorder: 'rgba(99,102,241,0.28)', badgeText: '#c4b5fd',
  },
};

const DEFAULT_THEME = {
  bg: '#060912',
  g1pos: '78% 40%', g1col: 'rgba(99,102,241,0.20)',
  g2pos: '18% 72%', g2col: 'rgba(56,189,248,0.10)',
  accent: '#a5b4fc', accentGlow: 'rgba(165,180,252,0.40)',
  text: '#f8fafc', muted: 'rgba(226,232,240,0.72)',
  badgeBg: 'rgba(165,180,252,0.12)', badgeBorder: 'rgba(165,180,252,0.24)', badgeText: '#c7d2fe',
};

const SERVICE_LOGO_VARIANTS = {
  wifi: [
    { src: '/logos/wifi/wifi-logo.svg', alt: 'WiFi' },
    { src: '/logos/wifi/wifi_icon_bold.png', alt: 'WiFi' },
  ],
  facebook: [
    { src: '/logos/facebook/Facebook_Logo_Primary.png', alt: 'Facebook' },
    { src: '/logos/facebook/Facebook_Logo_Secondary.png', alt: 'Facebook' },
  ],
  instagram: [
    { src: '/logos/instagram/Instagram_icon.png', alt: 'Instagram' },
    { src: '/logos/instagram/instagram-logo-splatter.png', alt: 'Instagram' },
  ],
  google_maps: [
    { src: '/logos/google/Google_Maps_icon_(2015-2020).svg.png', alt: 'Google Maps' },
    { src: '/logos/google/google-maps-pointer.png', alt: 'Google Maps' },
  ],
  google_review: [
    { src: '/logos/google/Google_Maps_icon_(2015-2020).svg.png', alt: 'Google' },
    { src: '/logos/google/google-maps-pointer.png', alt: 'Google' },
  ],
  tripadvisor: [
    { src: '/logos/tripadvisor/transparent-owl-logo-tripadvisor.png', alt: 'Tripadvisor' },
    { src: '/logos/tripadvisor/tripadvisor-logo-png_seeklogo.png', alt: 'Tripadvisor' },
  ],
};

const hashString = (value = '') => {
  const input = String(value || '');
  let hash = 0;
  for (let i = 0; i < input.length; i++) {
    hash = (hash * 31 + input.charCodeAt(i)) >>> 0;
  }
  return hash;
};

const pickServiceLogo = (defaultKey, templateId) => {
  const variants = SERVICE_LOGO_VARIANTS[String(defaultKey || '').trim().toLowerCase()];
  if (!variants || !variants.length) return null;
  const idx = hashString(`${defaultKey}:${templateId}`) % variants.length;
  return variants[idx] || null;
};

function TvPoster({ venue, qrDataUrl, copy = {}, details = [], visibleFields = {}, defaultKey, isMinimal = false, templateId = 'landscape-neon' }) {
  const serviceKey = String(defaultKey || '').toLowerCase().replace(/-/g, '_');
  const darkTheme = SERVICE_THEMES[serviceKey] || DEFAULT_THEME;

  const t = isMinimal
    ? {
        ...darkTheme,
        bg: '#f1f5f9',
        g1col: 'rgba(99,102,241,0.06)',
        g2col: 'rgba(16,185,129,0.05)',
        text: '#0f172a',
        muted: 'rgba(15,23,42,0.62)',
        badgeBg: 'rgba(15,23,42,0.05)',
        badgeBorder: 'rgba(15,23,42,0.14)',
        badgeText: darkTheme.accent,
      }
    : darkTheme;

  const logo = pickServiceLogo(defaultKey, templateId);

  const venueName = visibleFields.venue !== false ? (venue?.name || '') : '';
  const venueMeta = [
    visibleFields.address !== false ? (venue?.address || '') : '',
    visibleFields.website !== false ? (venue?.website || '') : '',
  ].filter(Boolean).join(' \u00b7 ');

  const showDetails = visibleFields.details !== false && details.length > 0;

  const cssVars = {
    '--wp-bg': t.bg,
    '--wp-g1-pos': t.g1pos,
    '--wp-g1-col': t.g1col,
    '--wp-g2-pos': t.g2pos,
    '--wp-g2-col': t.g2col,
    '--wp-text': t.text,
    '--wp-muted': t.muted,
    '--wp-accent': t.accent,
    '--wp-accent-glow': t.accentGlow,
    '--wp-badge-bg': t.badgeBg,
    '--wp-badge-border': t.badgeBorder,
    '--wp-badge-text': t.badgeText,
    '--wp-detail-bg': isMinimal ? 'rgba(15,23,42,0.05)' : 'rgba(255,255,255,0.07)',
    '--wp-detail-border': isMinimal ? 'rgba(15,23,42,0.12)' : 'rgba(255,255,255,0.12)',
    '--wp-detail-label': isMinimal ? t.accent : t.badgeText,
    '--wp-qr-border': t.accentGlow,
    '--wp-qr-shadow': isMinimal
      ? `0 8px 40px rgba(0,0,0,0.14), 0 0 0 2px ${t.accentGlow}`
      : `0 12px 60px rgba(0,0,0,0.5), 0 0 90px ${t.accentGlow}`,
  };

  return (
    <div className={`wp-screen${isMinimal ? ' wp-screen--light' : ''}`} style={cssVars}>
      <div className="wp-content">
        <div className="wp-badge">
          {logo ? (
            <img src={logo.src} alt={logo.alt} className="wp-badge-logo" draggable={false} />
          ) : null}
          <span className="wp-badge-kicker">{copy.kicker || 'Scan the QR code'}</span>
        </div>
        <h2 className="wp-headline">{copy.title || 'Scan to open'}</h2>
        {copy.sub ? <p className="wp-tagline">{copy.sub}</p> : null}
        {venueName ? (
          <div className="wp-venue">
            <div className="wp-venue-divider" />
            <div className="wp-venue-name">{venueName}</div>
            {venueMeta ? <div className="wp-venue-meta">{venueMeta}</div> : null}
          </div>
        ) : null}
      </div>
      <div className="wp-qr-side">
        <div className="wp-qr-frame">
          {qrDataUrl ? (
            <img src={qrDataUrl} alt={copy.qrAlt || 'QR code'} className="wp-qr-img" draggable={false} />
          ) : (
            <div className="wp-qr-placeholder">{copy.qrPlaceholder || 'QR code will appear once a URL is set.'}</div>
          )}
        </div>
        <p className="wp-qr-label">Point your phone camera at this code</p>
        {showDetails ? (
          <div className="wp-qr-details">
            {details.map((d) => (
              <div key={d.label} className="wp-qr-detail-row">
                <span className="wp-qr-detail-label">{d.label}</span>
                <span className="wp-qr-detail-value">{d.value}</span>
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
}

function LandscapeNeon(props) {
  return <TvPoster {...props} templateId="landscape-neon" />;
}

function LandscapeMinimal(props) {
  return <TvPoster {...props} templateId="landscape-minimal" isMinimal />;
}

function LandscapeParty(props) {
  return <TvPoster {...props} templateId="landscape-party" />;
}

function PortraitClassic(props) {
  return <TvPoster {...props} templateId="portrait-classic" />;
}

function PortraitStickers(props) {
  return <TvPoster {...props} templateId="portrait-stickers" />;
}

export const WIFI_POSTER_TEMPLATES = [
  {
    id: 'landscape-neon',
    name: 'Dark Vivid',
    description: 'Service-themed dark background, bold design.',
    orientation: 'landscape',
    emoji: '✨📶',
    Component: LandscapeNeon,
  },
  {
    id: 'landscape-minimal',
    name: 'Clean Light',
    description: 'Light professional look, great for clinics and offices.',
    orientation: 'landscape',
    emoji: '🧼📶',
    Component: LandscapeMinimal,
  },
  {
    id: 'landscape-party',
    name: 'Bold Dark',
    description: 'Vivid gradients, perfect for bars and events.',
    orientation: 'landscape',
    emoji: '🎉🎶',
    Component: LandscapeParty,
  },
  {
    id: 'portrait-classic',
    name: 'Portrait Classic',
    description: 'Upright poster layout for printing.',
    orientation: 'portrait',
    emoji: '🧾📱',
    Component: PortraitClassic,
  },
  {
    id: 'portrait-stickers',
    name: 'Portrait Bold',
    description: 'Tall format with a playful vibe.',
    orientation: 'portrait',
    emoji: '✨📱',
    Component: PortraitStickers,
  },
];

export const getWifiPosterTemplateById = (templateId) =>
  WIFI_POSTER_TEMPLATES.find((t) => t.id === templateId) || WIFI_POSTER_TEMPLATES[0];
